import _ from 'lodash';
import {
  FETCH_SETTINGS,
  FETCH_SETTINGS_FAIL,
  FETCH_SETTINGS_SUCCESS,
  ADD_CONTENT_TAG,
  ADD_CONTENT_TAG_SUCCESS,
  ADD_CONTENT_TAG_FAIL,
  GET_USERS_SUCCESS,
  GET_USERS_FAIL,
  GET_USER_INFO_SUCCESS,
  DELETE_SETTINGS_ITEM_SUCCESS,
  UPDATE_SHORT_DOMAIN_SUCCESS,
  UPDATE_SHORT_DOMAIN_FAIL,
  UPDATE_SHORT_DOMAIN,
  SET_LOADING,
  GET_INVOICES_SUCCESS,
  GET_INVOICES_FAIL,
  UPDATE_DIGEST_OPTION_SUCCESS,
  CREATE_NEW_COLLECTION_FAIL,
  DELETE_COLLECTION_SUCCESS,
  DELETE_COLLECTION_FAIL,
  GET_COLLECTIONS_SUCCESS,
  GET_COLLECTION_SUCCESS,
  CREATE_SITE_SUCCESS,
  GET_USER_SITE_CONTENT_SUCCESS
} from "../actions/settings";

import {
  GET_CTAS_LIST_SUCCESS,
  DELETE_CTA_SUCCESS,
} from "../actions/ctas";

import {
  GET_BRANDING_LIST_SUCCESS,
  DELETE_BRANDING_SUCCESS,
} from "../actions/brandings";

import { CHANGE_USER_ATTRIBUTE_SUCCESS } from "../actions/auth";


import { copyToClipboard } from "../utils/common";

import { USER_LOGOUT } from "../actions/auth";

// const initialState = {
//   tenantId: '',
//   id: '',
//   "contentTypes": {},
//   "contentCollections": {},
//   "funnelStages": {},
//   "contentTags": {},
//   "wishlistUrgency": {},
//   users: [],
//   error: null,
//   isLoading: false,
//   userInfo: null,
//   customShortDomain: {
//     prevDomain: 'ccml.io',
//     domain: 'ccml.io',
//     protocol: 'http',
//     target: "d1868hz443w9za.cloudfront.net",
//     status: "confirmed"
//   },
//   billingHistory: []
// };

const initialState = {};

const SettingsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SETTINGS:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case FETCH_SETTINGS_FAIL:
      return {
        ...initialState,
        users: state.users,
        userInfo: state.userInfo,
        error: action.error,
        isLoading: false,
      };
    case FETCH_SETTINGS_SUCCESS:
      const {
        brandingOptions,
        contentTypes,
        contentCollections,
        funnelStages,
        contentTags,
        contentProducts,
        contentIndustries,
        contentRegions,
        wishlistUrgency
      } = action.settings;
      const contentCollectionsKeys = Object.keys(contentCollections).sort((a, b) => contentCollections[a].sort - contentCollections[b].sort).filter(k => !contentCollections[k].deletedAt);
      const funnelStagesKeys = Object.keys(funnelStages).sort((a, b) => {
        if (funnelStages[a].stage !== funnelStages[b].stage) {
          return funnelStages[a].stage - funnelStages[b].stage;
        } else {
          if (a.toLowerCase() > b.toLowerCase()) {
            return 1;
          } else if (a.toLowerCase() === b.toLowerCase()) {
            return 0;
          } else {
            return -1;
          }
        }
      }).filter(k => !funnelStages[k].deletedAt);
      const contentTypeKeys = Object.keys(contentTypes || {}).sort((a, b) => contentTypes[a].sort - contentTypes[b].sort).filter(k => !contentTypes[k].deletedAt);
      const contentTagsKeys = Object.keys(contentTags).sort((a, b) => contentTags[a].sort - contentTags[b].sort).filter(k => !contentTags[k].deletedAt);
      const contentProductsKeys = Object.keys(contentProducts || {}).sort((a, b) => contentProducts[a].sort - contentProducts[b].sort).filter(k => !contentProducts[k].deletedAt);
      const contentIndustriesKeys = Object.keys(contentIndustries || {}).sort((a, b) => contentIndustries[a].sort - contentIndustries[b].sort).filter(k => !contentIndustries[k].deletedAt);
      const contentRegionsKeys = Object.keys(contentRegions || {}).sort((a, b) => contentRegions[a].sort - contentRegions[b].sort).filter(k => !contentRegions[k].deletedAt);
      const wishlistUrgencyKeys = Object.keys(wishlistUrgency).sort((a, b) => wishlistUrgency[a].sort - wishlistUrgency[b].sort).filter(k => !wishlistUrgency[k].deletedAt);

      const newContentTypes = {};
      contentTypeKeys.forEach(key => {
        newContentTypes[key] = contentTypes[key];
      });

      const newContentCollections = {};
      contentCollectionsKeys.forEach(key => {
        newContentCollections[key] = contentCollections[key];
      });

      const newFunnelStages = {};
      funnelStagesKeys.forEach(key => {
        newFunnelStages[key] = funnelStages[key];
      });

      const newContentProducts = {};
      contentProductsKeys.forEach(key => {
        newContentProducts[key] = contentProducts[key];
      });

      const newContentIndustries = {};
      contentIndustriesKeys.forEach(key => {
        newContentIndustries[key] = contentIndustries[key];
      });

      const newContentRegions = {};
      contentRegionsKeys.forEach(key => {
        newContentRegions[key] = contentRegions[key];
      });

      const newContentTags = {};
      contentTagsKeys.forEach(key => {
        newContentTags[key] = contentTags[key];
      });

      const newWishlistUrgency = {};
      wishlistUrgencyKeys.forEach(key => {
        newWishlistUrgency[key] = wishlistUrgency[key];
      });

      return {
        ...state,
        ...action.settings,
        brandingOptions,
        contentTypes: newContentTypes,
        contentCollections: newContentCollections,
        funnelStages: newFunnelStages,
        contentProducts: newContentProducts,
        contentIndustries: newContentIndustries,
        contentRegions: newContentRegions,
        contentTags: newContentTags,
        wishlistUrgency: newWishlistUrgency,
        customShortDomain: action.settings.customShortDomain,
        error: null,
        isLoading: false
      };
    case ADD_CONTENT_TAG:
      return {
        ...state,
        isLoading: true,
        error: null
      };
    case UPDATE_DIGEST_OPTION_SUCCESS: {
      return {
        ...state,
        digestOption: action.settings.digestOption,
        isLoading: false,
        error: null
      };
    }
    case ADD_CONTENT_TAG_FAIL:
      return {
        ...state,
        error: action.error,
        isLoading: false,
      };
    case ADD_CONTENT_TAG_SUCCESS: {
      const { contentTags } = state;
      contentTags[action.tag.key] = {
        color: action.tag.color,
        sort: 101
      }

      const contentTagsKeys = Object.keys(contentTags).sort((a, b) => contentTags[a].sort - contentTags[b].sort);

      const newContentTags = {};
      contentTagsKeys.forEach(key => {
        newContentTags[key] = contentTags[key];
      });

      return {
        ...state,
        error: null,
        isLoading: false,
        contentTags: newContentTags,
      };
    }
    case DELETE_SETTINGS_ITEM_SUCCESS: {
      const listName = action.params.listName;
      const itemName = action.params.itemName;
      const tags = state[listName];
      delete tags[itemName];

      return {
        ...state,
        [listName]: {
          ...tags
        }
      };
    }
    case GET_USERS_SUCCESS: {
      return {
        ...state,
        error: null,
        isLoading: false,
        users: action.users
      };
    }
    case GET_USERS_FAIL: {
      return {
        ...state,
        error: action.error,
        isLoading: false,
        users: []
      };
    }
    case GET_USER_INFO_SUCCESS: {
      return {
        ...state,
        error: null,
        isLoading: false,
        userInfo: action.user
      };
    }
    case CHANGE_USER_ATTRIBUTE_SUCCESS: {
      return {
        ...state,
        error: null,
        isLoading: false,
        userInfo: {
          ...state.userInfo,
          [action.params.name]: action.params.value
        }
      }
    }
    case UPDATE_SHORT_DOMAIN: {
      return {
        ...state,
        error: null,
        isLoading: true
      };
    }
    case UPDATE_SHORT_DOMAIN_FAIL: {
      return {
        ...state,
        error: action.error,
        isLoading: false
      };
    }
    case UPDATE_SHORT_DOMAIN_SUCCESS: {
      return {
        ...state,
        error: null,
        isLoading: false,
        customShortDomain: action.settings.customShortDomain
      };
    }
    case USER_LOGOUT: {
      return {};
    }
    case SET_LOADING: {
      return {
        ...state,
        error: null,
        isLoading: true
      };
    }
    case GET_INVOICES_SUCCESS: {
      return {
        ...state,
        error: null,
        isLoading: false,
        billingHistory: action.invoices
      };
    }
    case GET_INVOICES_FAIL: {
      return {
        ...state,
        error: action.error,
        isLoading: false
      };
    }
    // case CREATE_NEW_COLLECTION_SUCCESS: {
    //   const collections = state.collections || [];
    //   collections.push(action.collection);

    //   return {
    //     ...state,
    //     collections
    //   };
    // }
    case CREATE_NEW_COLLECTION_FAIL: {
      return {
        ...state,
        error: action.error,
        isLoading: false
      };
    }
    case DELETE_COLLECTION_SUCCESS: {
      let collections = state.collections || [];
      collections = collections.filter(c => c.title !== action.collection.title);

      return {
        ...state,
        collections
      };
    }
    case DELETE_COLLECTION_FAIL: {
      return {
        ...state,
        error: action.error,
        isLoading: false
      };
    }
    // fetching MULTIPLE collections
    case GET_COLLECTIONS_SUCCESS: {
      return {
        ...state,
        collections: action.collections,
        isLoading: false
      };
    }
    // fetching SINGLE collection
    case GET_COLLECTION_SUCCESS: {
      // console.log({ state, action });
      const collections = (state.userSiteContent && state.userSiteContent.collections) || [];
      const collectionIndex = collections.findIndex(col => col.id === action.collection.id);

      if (collectionIndex >= 0) {
        collections[collectionIndex] = action.collection;
      } else {
        // not found, add it
        collections.push(action.collection);
      }
      

      return {
        ...state,
        userSiteContent: { 
          ...state.userSiteContent, 
          collections },
        isLoading: false
      };
    }
    case CREATE_SITE_SUCCESS: {
      const siteUrl = _.get(action, "site.urlPath");
      if (siteUrl) {
        copyToClipboard(action.site.urlPath, "Copied share URL of site to clipboard.");
      }
      return {
        ...state,
        isLoading: false
      };
    }
    case GET_USER_SITE_CONTENT_SUCCESS: {
      // console.log({ userContent: action.userContent, state, info: action.type })
      
      return {
        ...state,
        userSiteContent: action.userContent || {
          collections: []
        }
      };
    }
    case GET_CTAS_LIST_SUCCESS: {
      return {
        ...state,
        ctas: action.ctas
      };
    }
    case DELETE_CTA_SUCCESS: {
      let newCtas = [...state.ctas || []];
      newCtas = newCtas.filter(ct => ct.id !== action.id)

      return {
        ...state,
        ctas: newCtas
      };
    }
    case GET_BRANDING_LIST_SUCCESS: {
      return {
        ...state,
        brandings: action.brandings
      };
    }
    case DELETE_BRANDING_SUCCESS: {
      let newBrandings = [...state.brandings || []];
      newBrandings = newBrandings.filter(branding => branding.name !== action.name)

      return {
        ...state,
        brandings: newBrandings
      };
    }
    default:
      return state;
  }
}

export default SettingsReducer;
